import React from 'react';
import { X } from 'lucide-react';
import { format } from 'date-fns';
import { Invoice } from '@/services/types/invoice.types';
import InvoicePreview from '@/components/molecules/invoice/InvoicePreview';
import { Budget } from '@/services/types/budgets.types';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import InvoiceInfo from './InvoiceInfo';
import { Button } from '@/components/ui/button';
import { PAGE } from 'src/routes';
import { useNavigate } from 'react-router-dom';

interface InvoiceOverviewSidebarProps {
  invoice: Invoice & { budget?: Budget };
  onClose: () => void;
  /** When provided (e.g. from budget route), "See Invoice Details" navigates to budget's invoice detail */
  budgetId?: string;
}

const InvoiceOverviewSidebar = ({ invoice, onClose, budgetId }: InvoiceOverviewSidebarProps) => {
  const navigate = useNavigate();

  const handleSeeDetails = () => {
    if (budgetId) {
      navigate(`${PAGE.BUDGETS.path}/${budgetId}/invoices/${invoice._id}`, {
        state: { budget: invoice.budget }
      });
    } else {
      navigate(`${PAGE.INVOICE.path}/${invoice._id}`, { state: { budget: invoice.budget } });
    }
  };
  const invoiceInfoItems: {
    label: string;
    value: string | Date | string[] | React.ReactNode | undefined;
    tooltipText?: string;
    type: 'image' | 'date';
    span: number;
  }[] = [
    {
      label: 'Image',
      value: invoice.invoice_images_url,
      type: 'image',
      span: 2
    },
    {
      label: 'Issue date',
      value: invoice.payment_issue_date,
      tooltipText: 'The date the invoice was issued.',
      type: 'date',
      span: 1
    },
    {
      label: 'Payment term',
      value: invoice.payment_term_date,
      tooltipText: 'The date the invoice was due.',
      type: 'date',
      span: 1
    },
    {
      label: 'Payment date',
      value: invoice.payment_date,
      tooltipText: 'The date the invoice was paid.',
      type: 'date',
      span: 1
    }
  ];
  console.log('invoice dsa', invoice);

  return (
    <aside className="w-[360px] flex flex-col border bg-white p-4 rounded-[16px] space-y-8 overflow-y-auto">
      <header className="flex items-center justify-between">
        <p className="font-semibold">Invoice Detail</p>

        <button type="button" onClick={onClose} className="hover:opacity-70 transition-opacity">
          <X className="w-[22px] h-[22px] text-[#495057]" />
        </button>
      </header>

      <InvoicePreview invoice={invoice} />

      <div className="flex-1">
        <InvoiceInfo items={invoiceInfoItems} />
      </div>
      <Button variant="default" className="w-full rounded-full text-base mt-auto mb-0" onClick={handleSeeDetails}>
        See Invoice Details
      </Button>
    </aside>
  );
};

export default InvoiceOverviewSidebar;
